import InnerComponent from '@Components/Sales/Customer/CustomerHome';
import orgContainer from '@Components/AppContainer';

const Customers = () => ((orgContainer(InnerComponent)));
export default Customers;
